// TableComponent.tsx
import React from 'react'
import styles from './style.module.scss'

interface TableProps {
  tableData: string[][]
}

const TableComponent: React.FC<TableProps> = ({ tableData }) => {
  const renderRow = (row: string[], rowIndex: number) => {
    const isHeaderRow = rowIndex === 0
    const isRemarkRow = row[0] === 'Remarks'

    return (
      <tr key={rowIndex} className={`${isHeaderRow ? styles.headerRow : ''} ${isRemarkRow ? styles.remarkRow : ''}`}>
        {row.map((cell, cellIndex) => (
          <td
            key={cellIndex}
            className={`
              ${isHeaderRow ? styles.headerCell : ''}
              ${cellIndex === 0 ? styles.labelCell : ''}
              ${isRemarkRow ? styles.remarkCell : ''}
            `}
          >
            {cell}
          </td>
        ))}
      </tr>
    )
  }

  return (
    <div className={styles.tableContainer}>
      <table className={styles.dataTable}>
        <tbody>{tableData.map((row, index) => renderRow(row, index))}</tbody>
      </table>
    </div>
  )
}

export default TableComponent
